import { Screen } from '@/interfaces/FlowInterfaces'

export function ensureJsonObject(value: unknown): Record<string, unknown> {
  if (value != null && typeof value === 'object' && !Array.isArray(value)) {
    return value as Record<string, unknown>
  }

  return {}
}

export function getFormChildren(screen: Screen): any[] {
  const layoutChildren = screen?.layout?.children

  if (!Array.isArray(layoutChildren) || layoutChildren.length === 0) {
    return []
  }

  const form = layoutChildren[0]

  if (form?.type !== 'Form' || !Array.isArray(form.children)) {
    return []
  }

  return form.children
}

function sanitizeFlowComponent(child: Record<string, unknown>): void {
  if (child['helper-text'] == null || child['helper-text'] === '') {
    delete child['helper-text']
  }

  if (child.type !== 'Footer' || !child['on-click-action']) {
    return
  }

  const action = child['on-click-action'] as Record<string, unknown>
  const actionName = action.name

  if (actionName === 'navigate' || actionName === 'complete') {
    action.payload = ensureJsonObject(action.payload)
  }
}

export function sanitizeFlowJsonForMeta(flow: Record<string, unknown>): Record<string, unknown> {
  const screens = flow.screens as Screen[] | undefined

  if (!Array.isArray(screens)) {
    return flow
  }

  screens.forEach((screen) => {
    screen.data = ensureJsonObject(screen.data) as Screen['data']

    getFormChildren(screen).forEach((child) => {
      sanitizeFlowComponent(child as Record<string, unknown>)
    })
  })

  return flow
}
